<button
  (click)="goToBack()"
  class="back-button">
  <img
    src="assets/img/back-btn.svg"
    alt="Back button"
    class="back-button__icon">
</button>
